import React from 'react';

/* eslint-disable max-len,no-tabs,camelcase */
const Eyes_4 = ({ eyeColours, skinColours }) => {
  const colour0 = "#F15743";
  const colour1 = "#FFFEF0";
  const colour2 = "#F6E7D0";
  const colour3 = eyeColours.shadow;
  const colour4 = "#DF5656";
  const colour5 = skinColours.shadow;

  return (
    <>
      <g>
        <g>
          <path
            fill={colour0}
            opacity={0.5}
            d="M334.8,387c-2.6-0.7-6.6-3.5-6.8-4.4c-0.2-1,8.2-9.1,8.2-9.1L334.8,387z"
          />
          <path
            fill={colour0}
            opacity={0.5}
            d="M382.7,390.2c2.8-0.7,7-3.5,7.1-4.4c0.2-1-7-9.1-7-9.1L382.7,390.2z"
          />
          <path
            fill={colour0}
            opacity={0.5}
            d="M384.8,385.8c0-15.5-12.5-29-26.6-29c-14.1,0-25.5,12.6-25.5,28.1c0,15.5,11.4,28.1,25.5,28.1
			C372.3,413,384.8,401.4,384.8,385.8z"
          />
          <path
            fill={colour1}
            d="M381.6,384.9c0-15-10.4-27.1-23.3-27.1c-12.9,0-23.3,12.1-23.3,27.1c0,15,10.4,24.5,23.3,24.5
			C371.1,409.4,381.6,399.9,381.6,384.9z"
          />
          <path
            fill={colour2}
            d="M359.5,405.9c-12.9,0-23.3-10.3-23.3-25.3c0-2.4,0.3-4.8,0.8-7c-1.3,3.4-2.1,7.2-2.1,11.2
			c0,15,10.4,25.3,23.3,25.3c10.9,0,20.1-7.4,22.6-18.9C377.3,400.3,369.1,405.9,359.5,405.9z"
          />
          <path
            fill={colour3}
            d="M368.1,385.6c0-6-4.6-10.9-10.2-10.9c-5.6,0-10.2,4.9-10.2,10.9c0,6,4.6,10.9,10.2,10.9
			C363.6,396.5,368.1,391.6,368.1,385.6z"
          />
          <path
            fill={colour4}
            opacity={0.5}
            d="M389.8,385.7c-6-13.5-15.3-26.7-29.7-26.7c-12.9,0-29.3,10.7-31.6,23.3C345.6,368.9,375.3,368.5,389.8,385.7z
			"
          />
          <path
            fill={colour5}
            d="M329.3,379.8c4-11.4,36-27.8,59.2,3.2c0,0-4.8-27.5-28.9-27.5C331.6,355.5,329.3,379.8,329.3,379.8z"
          />
          <path
            fill={colour5}
            d="M328.9,377c-0.7,3.3-0.9,5.5-0.9,5.5c3.3-12.4,37-30.2,61.8,3.3c0,0-0.2-1.8-0.8-4.6
			C367,351.8,338.5,362.5,328.9,377z"
          />
          <path
            fill={colour1}
            d="M369.8,386.7c0-2.2-1.4-4-3.1-4c-1.7,0-3.1,1.8-3.1,4c0,2.2,1.4,4,3.1,4C368.4,390.7,369.8,388.9,369.8,386.7
			z"
          />
          <path
            fill={colour1}
            d="M363.9,379.5c-0.5-1.2-1.4-1.9-2.1-1.6c-0.7,0.3-0.8,1.4-0.4,2.6c0.5,1.2,1.4,1.9,2.1,1.6
			C364.2,381.8,364.4,380.7,363.9,379.5z"
          />
        </g>
        <g>
          <path
            fill={colour0}
            opacity={0.5}
            d="M435.5,391.8c-2.6-0.7-6.6-3.5-6.8-4.4c-0.2-1,8.2-9.1,8.2-9.1L435.5,391.8z"
          />
          <path
            fill={colour0}
            opacity={0.5}
            d="M483.4,395.1c2.8-0.7,7-3.5,7.1-4.4c0.2-1-7-9.1-7-9.1L483.4,395.1z"
          />
          <path
            fill={colour0}
            opacity={0.5}
            d="M485.6,390.7c0-15.5-12.5-29-26.6-29s-25.5,12.6-25.5,28.1c0,15.5,11.4,28.1,25.5,28.1
			S485.6,406.2,485.6,390.7z"
          />
          <path
            fill={colour1}
            d="M482.4,389.8c0-15-10.4-27.1-23.3-27.1c-12.9,0-23.3,12.1-23.3,27.1c0,15,10.4,24.5,23.3,24.5
			C471.9,414.3,482.4,404.7,482.4,389.8z"
          />
          <path
            fill={colour2}
            d="M460.3,410.8c-12.9,0-23.3-10.3-23.3-25.3c0-2.4,0.3-4.8,0.8-7c-1.3,3.4-2.1,7.2-2.1,11.2
			c0,15,10.4,25.3,23.3,25.3c10.9,0,20.1-7.4,22.6-18.9C478.1,405.2,469.9,410.8,460.3,410.8z"
          />
          <path
            fill={colour3}
            d="M468.9,390.5c0-6-4.6-10.9-10.2-10.9c-5.6,0-10.2,4.9-10.2,10.9c0,6,4.6,10.9,10.2,10.9
			C464.3,401.3,468.9,396.5,468.9,390.5z"
          />
          <path
            fill={colour4}
            opacity={0.5}
            d="M490.6,390.6c-6-13.5-15.3-26.7-29.7-26.7c-12.9,0-29.3,10.7-31.6,23.3C446.4,373.7,476,373.4,490.6,390.6z"
          />
          <path
            fill={colour5}
            d="M430.1,384.7c4-11.4,36-27.8,59.2,3.2c0,0-4.8-27.5-28.9-27.5C432.4,360.4,430.1,384.7,430.1,384.7z"
          />
          <path
            fill={colour5}
            d="M429.7,381.8c-0.7,3.3-0.9,5.5-0.9,5.5c3.3-12.4,37-30.2,61.8,3.3c0,0-0.2-1.8-0.8-4.6
			C467.7,356.7,439.3,367.4,429.7,381.8z"
          />
          <path
            fill={colour1}
            d="M470.6,391.5c0-2.2-1.4-4-3.1-4c-1.7,0-3.1,1.8-3.1,4c0,2.2,1.4,4,3.1,4C469.2,395.5,470.6,393.7,470.6,391.5
			z"
          />
          <path
            fill={colour1}
            d="M464.7,384.4c-0.5-1.2-1.4-1.9-2.1-1.6c-0.7,0.3-0.8,1.4-0.4,2.6c0.5,1.2,1.4,1.9,2.1,1.6
			C465,386.7,465.1,385.5,464.7,384.4z"
          />
        </g>
      </g>
    </>
  );
};

export default Eyes_4;
